var _defs, _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBarbecueSchedule(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 153.74 143.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #ff5c0d;\n        stroke-miterlimit: 10;\n        stroke-width: 3.74px;\n      }\n\n      .cls-2 {\n        fill: #e7e4e2;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 76.87,
    cy: 71.92,
    r: 63.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M151.49,129.54c-8.07-11.07-13.91-23.16-17.27-36.38-.73-6.66-6.06-11.8-12.35-12.25-6.96-.5-13.48,4.84-14.33,12.25-1.21,9.22-4.91,14.9-6.87,19-2.89,6.06-6.37,11.85-10.4,17.38-1,1.37,.1,3.19,1.93,3.19h57.37c1.82,0,2.92-1.82,1.93-3.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M110.94,134.63c2.18,4.43,5.86,7.33,10.04,7.33s7.88-2.92,10.05-7.36"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 51.76,
    y1: 15.51,
    x2: 102.13,
    y2: 15.51
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M77.56,133.05H10.09c-4.54,0-8.22-3.68-8.22-8.22V23.73c0-4.54,3.68-8.22,8.22-8.22h5.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M138.89,15.51h4.76c4.54,0,8.22,3.68,8.22,8.22V109.38"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33.46,29.16h0c-4,0-7.24-3.24-7.24-7.24V9.11c0-4,3.24-7.24,7.24-7.24h0c4,0,7.24,3.24,7.24,7.24v12.82c0,4-3.24,7.24-7.24,7.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M120.28,29.16h0c-4,0-7.24-3.24-7.24-7.24V9.11c0-4,3.24-7.24,7.24-7.24h0c4,0,7.24,3.24,7.24,7.24v12.82c0,4-3.24,7.24-7.24,7.24Z"
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1.87,
    y1: 41.48,
    x2: 151.87,
    y2: 41.48
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.95,61.49h4.61c2.65,0,4.81,2.15,4.81,4.81v4.62c0,2.65-2.15,4.81-4.81,4.81h-4.61c-2.65,0-4.81-2.15-4.81-4.81v-4.61c0-2.65,2.15-4.81,4.81-4.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M86.33,110.21v-4.56c0-1.24,1.01-2.25,2.25-2.25h4.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.95,98.6h4.61c2.65,0,4.81,2.15,4.81,4.81v4.61c0,2.65-2.15,4.81-4.81,4.81h-4.61c-2.65,0-4.81-2.15-4.81-4.81v-4.61c0-2.65,2.15-4.81,4.81-4.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M57.04,61.49h4.61c2.65,0,4.81,2.15,4.81,4.81v4.61c0,2.65-2.15,4.81-4.81,4.81h-4.61c-2.65,0-4.81-2.15-4.81-4.81v-4.61c0-2.65,2.15-4.81,4.81-4.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M91.12,61.49h4.61c2.65,0,4.81,2.15,4.81,4.81v4.61c0,2.65-2.15,4.81-4.81,4.81h-4.61c-2.65,0-4.81-2.15-4.81-4.81v-4.61c0-2.65,2.15-4.81,4.81-4.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M120.4,73.47v-9.74c0-1.24,1.01-2.25,2.25-2.25h9.74c1.24,0,2.25,1.01,2.25,2.25v9.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M57.05,98.6h4.61c2.65,0,4.81,2.15,4.81,4.81v4.61c0,2.65-2.15,4.81-4.81,4.81h-4.61c-2.65,0-4.81-2.15-4.81-4.81v-4.61c0-2.65,2.15-4.81,4.81-4.81Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarbecueSchedule);
export default __webpack_public_path__ + "static/media/barbecueSchedule.777671966aaa7f88802437377c479613.svg";
export { ForwardRef as ReactComponent };